import styled from 'styled-components'

export const MessageContainer = styled.div`
  position: relative;
  width: 100%;
  padding: 0.5rem;

  font: normal normal normal 14px/17px Inter;
  text-align: center;
  color: ${props => props.theme.colors.color856404};

  background-color: ${props => props.theme.colors.colorfff3cd};
  border: 1px solid ${props => props.theme.colors.colorffeeba};
  border-radius: 0.25rem;

  b {
    font-weight: 700;
    color: ${props => props.theme.colors.color533f03};
  }
`
